import { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import Layout from './Layout';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

const empty = { last_name: '', first_name: '', middle_name: '', birth_date: '' };

function downloadTemplate() {
  const content = '﻿Фамилия;Имя;Отчество;Дата рождения\nИванов;Иван;Иванович;01.01.1980\n';
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = 'stoplist_template.csv';
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export default function Stoplist() {
  const [list, setList] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState(empty);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importBusy, setImportBusy] = useState(false);
  const [importErr, setImportErr] = useState('');
  const [importResult, setImportResult] = useState(null);
  const fileInputRef = useRef(null);
  const headers = { Authorization: 'Bearer ' + localStorage.getItem('clinicToken') };

  const load = useCallback(() => {
    axios.get(`${API}/clinic-cabinet/stoplist`, { headers }).then(r => setList(r.data)).catch(() => {});
    // eslint-disable-next-line
  }, []);
  useEffect(() => { load(); }, [load]);

  const open = () => { setForm(empty); setErr(''); setShow(true); };

  const save = async () => {
    if (!form.last_name.trim() || !form.first_name.trim() || !form.middle_name.trim() || !form.birth_date) {
      setErr('Заполните ФИО и дату рождения'); return;
    }
    setBusy(true); setErr('');
    try {
      await axios.post(`${API}/clinic-cabinet/stoplist`, form, { headers });
      setShow(false); load();
    } catch (e) { setErr(e?.response?.data?.detail || 'Ошибка'); } finally { setBusy(false); }
  };

  const openImport = () => { setImportFile(null); setImportErr(''); setImportResult(null); setShowImport(true); };

  const runImport = async () => {
    if (!importFile) { setImportErr('Выберите CSV-файл'); return; }
    setImportBusy(true); setImportErr(''); setImportResult(null);
    try {
      const fd = new FormData();
      fd.append('file', importFile);
      const r = await axios.post(`${API}/clinic-cabinet/stoplist/import`, fd, { headers });
      setImportResult(r.data);
      setImportFile(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
      load();
    } catch (e) { setImportErr(e?.response?.data?.detail || 'Ошибка загрузки файла'); } finally { setImportBusy(false); }
  };

  return (
    <Layout>
      <div style={s.topRow}>
        <h1 style={s.h1}>Стоп-лист врачей</h1>
        <div style={s.topBtns}>
          <button style={s.btnSecondary} onClick={openImport}>Добавить списком</button>
          <button style={s.btn} onClick={open}>+ Добавить врача</button>
        </div>
      </div>
      <div style={s.note}>
        В стоп-лист можно добавить только врача, который ещё <b>НЕ направлял</b> к вам пациентов. Врач из стоп-листа не увидит вас при привязке пациента.
      </div>
      <div style={s.note}>
        Данные врача (ФИО и дату рождения) вводятся вручную. <b>Удаление из стоп-листа — только через техподдержку.</b>
      </div>

      <div style={s.table}>
        <div style={{ ...s.head, gridTemplateColumns: cols }}><div>Врач</div><div>Дата рождения</div><div>Добавлен</div></div>
        {list.map(d => (
          <div key={d.id} style={{ ...s.row, gridTemplateColumns: cols }}>
            <div style={s.strong}>
              {d.doctor_name}
              {d.registered && <span style={s.tagReg}>в Refero</span>}
            </div>
            <div style={s.muted}>{d.birth_date ? new Date(d.birth_date).toLocaleDateString('ru') : '—'}</div>
            <div style={s.muted}>{new Date(d.added_at).toLocaleDateString('ru')}</div>
          </div>
        ))}
        {list.length === 0 && <div style={s.empty}>Стоп-лист пуст</div>}
      </div>

      {show && (
        <div style={s.overlay} onClick={() => setShow(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <h3 style={s.modalTitle}>Добавить врача в стоп-лист</h3>
            <div style={s.modalHint}>Введите данные врача. Удалить запись потом можно будет только через техподдержку.</div>
            <div style={s.modalRow}>
              <input style={s.input} placeholder="Фамилия *" value={form.last_name} onChange={e => setForm({ ...form, last_name: e.target.value })} />
              <input style={s.input} placeholder="Имя *" value={form.first_name} onChange={e => setForm({ ...form, first_name: e.target.value })} />
            </div>
            <input style={s.inputFull} placeholder="Отчество *" value={form.middle_name} onChange={e => setForm({ ...form, middle_name: e.target.value })} />
            <label style={s.label}>Дата рождения *</label>
            <input style={s.inputFull} type="date" value={form.birth_date} onChange={e => setForm({ ...form, birth_date: e.target.value })} />
            {err && <div style={s.err}>{err}</div>}
            <div style={s.modalBtns}>
              <button style={s.btnSecondary} onClick={() => setShow(false)}>Отмена</button>
              <button style={s.btn} onClick={save} disabled={busy}>{busy ? 'Сохранение…' : 'Добавить'}</button>
            </div>
          </div>
        </div>
      )}

      {showImport && (
        <div style={s.overlay} onClick={() => setShowImport(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <h3 style={s.modalTitle}>Добавить врачей списком (CSV)</h3>
            <div style={s.modalHint}>
              Файл CSV с колонками: Фамилия, Имя, Отчество, Дата рождения (ДД.ММ.ГГГГ). Первая строка может быть заголовком.
              Применяются те же правила: врача, который уже направлял вам пациентов, добавить нельзя — такие строки будут пропущены с пояснением.
            </div>
            <button style={s.linkBtn} onClick={downloadTemplate}>Скачать шаблон CSV</button>
            <input ref={fileInputRef} type="file" accept=".csv,text/csv" style={s.inputFull}
              onChange={e => setImportFile(e.target.files[0] || null)} />
            {importErr && <div style={s.err}>{importErr}</div>}
            {importResult && (
              <div style={s.importReport}>
                <div style={s.importReportLine}>Добавлено: <b style={{ color: '#149e90' }}>{importResult.added}</b> из {importResult.total_rows}</div>
                {importResult.skipped.length > 0 && (
                  <details style={s.details}>
                    <summary>Пропущено ({importResult.skipped.length})</summary>
                    {importResult.skipped.map((row, i) => (
                      <div key={i} style={s.reportRow}>Строка {row.row}{row.name ? ` (${row.name})` : ''}: {row.reason}</div>
                    ))}
                  </details>
                )}
                {importResult.errors.length > 0 && (
                  <details style={s.details}>
                    <summary style={{ color: '#dc2626' }}>Ошибки ({importResult.errors.length})</summary>
                    {importResult.errors.map((row, i) => (
                      <div key={i} style={s.reportRow}>Строка {row.row}{row.name ? ` (${row.name})` : ''}: {row.reason}</div>
                    ))}
                  </details>
                )}
              </div>
            )}
            <div style={s.modalBtns}>
              <button style={s.btnSecondary} onClick={() => setShowImport(false)}>Закрыть</button>
              <button style={s.btn} onClick={runImport} disabled={importBusy}>{importBusy ? 'Загрузка…' : 'Загрузить'}</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

const cols = '2fr 1fr 1fr';
const s = {
  topRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 },
  topBtns: { display: 'flex', gap: 10 },
  h1: { color: '#1B2B4B', fontSize: 24, fontWeight: 700, margin: 0 },
  note: { color: '#64748b', fontSize: 13, background: '#fff', border: '1px solid #eef2f7', borderRadius: 10, padding: '10px 16px', marginBottom: 12, lineHeight: 1.5 },
  table: { background: '#fff', borderRadius: 16, overflow: 'hidden', boxShadow: '0 4px 16px rgba(27,43,75,0.05)', marginTop: 8 },
  head: { display: 'grid', padding: '14px 20px', color: '#64748b', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', borderBottom: '1px solid #eef2f7' },
  row: { display: 'grid', padding: '14px 20px', borderBottom: '1px solid #f4f7fb', fontSize: 14, color: '#1B2B4B', alignItems: 'center' },
  strong: { fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 },
  tagReg: { fontSize: 11, fontWeight: 600, color: '#149e90', background: '#e9faf7', padding: '2px 8px', borderRadius: 20 },
  muted: { color: '#94a3b8', fontSize: 13 },
  empty: { color: '#94a3b8', textAlign: 'center', padding: '40px 0' },
  btn: { background: '#2EC4B6', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' },
  btnSecondary: { background: '#f5f7fa', color: '#1B2B4B', border: '1px solid #e2e8f0', borderRadius: 10, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: '#fff', borderRadius: 16, padding: 28, width: 440, maxWidth: '90vw', display: 'flex', flexDirection: 'column', gap: 12, boxShadow: '0 8px 40px rgba(0,0,0,0.2)' },
  modalTitle: { fontSize: 18, fontWeight: 700, color: '#1B2B4B', margin: 0 },
  modalHint: { fontSize: 13, color: '#64748b', lineHeight: 1.5 },
  modalRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 },
  input: { padding: '11px 14px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 14, outline: 'none', width: '100%', boxSizing: 'border-box' },
  inputFull: { padding: '11px 14px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  label: { fontSize: 12, color: '#888', marginBottom: -6 },
  err: { background: '#fef2f2', border: '1px solid #fca5a5', color: '#dc2626', padding: '10px 14px', borderRadius: 8, fontSize: 13 },
  modalBtns: { display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 6 },
  linkBtn: { background: 'none', border: 'none', color: '#149e90', fontSize: 13, fontWeight: 600, cursor: 'pointer', padding: 0, textAlign: 'left', textDecoration: 'underline' },
  importReport: { background: '#f5f7fa', borderRadius: 10, padding: '12px 14px', fontSize: 13, color: '#1B2B4B' },
  importReportLine: { marginBottom: 4 },
  details: { marginTop: 6, fontSize: 12, color: '#64748b' },
  reportRow: { padding: '4px 0 4px 12px', borderTop: '1px solid #e2e8f0' },
};
